import { LocalizedText, useUrlSyncedTableState } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Table, TableActiveColumnFilters, TableHeader, TableProvider } from '@optimus-web/core';
import {
    PortfolioCentralRateGroupOverview,
    PortfolioCentralRateGroupOverviewFilters,
} from '@mews-commander/data-access';
import { usePortfolioCentralRateGroupOverview } from '../../../queries';
import { centralRateGroupColumns } from './tableMapping';

export const CentralRateGroupsTable = () => {
    const [tableState, setTableState] = useUrlSyncedTableState<
        PortfolioCentralRateGroupOverview,
        PortfolioCentralRateGroupOverviewFilters
    >({
        columns: centralRateGroupColumns,
        pageSize: 50,
    });

    const { data, isFetching } = usePortfolioCentralRateGroupOverview(tableState);

    return (
        <>
            <TableProvider columns={centralRateGroupColumns} state={tableState} onStateChange={setTableState} as="div">
                <TableHeader
                    title={<LocalizedText textKey={TextKey.RateGroupTableTitle} />}
                    subTitle={data?.totalRowCount || '0'}
                />
                <TableActiveColumnFilters />
                <Table
                    uniqueRowId="id"
                    data={data?.data || []}
                    amountOfRows={data?.totalRowCount ?? 0}
                    loading={isFetching}
                    fixedFirstColumn
                />
            </TableProvider>
        </>
    );
};
